<template>
  <div class="picture-placeholder-container" :style="{ background: backgroundColor}">
    <div class="picture-placeholder-picture" :style="{ backgroundImage: 'url(' + pictureUrl + ')' }"></div>
    <div class="picture-placeholder-initials" :style="{ color: color, fontSize: fontSize }" v-if="showInitials"> {{textDisplay}} </div>
  </div>
</template>

<script>

export default {
  name: "PicturePlaceholder",
  props: {
          textIn: {
        type: String,
        required: false,
        default: () => ""
      },
      pictureUrl: {
        type: String,
        required: false,
        default: () => null
      },
      color: {
        type: String,
        required: false,
        default: () => "#000"
      },
      backgroundColor: {
        type: String,
        required: false,
        default: () => "#898c7f"
      },
      fontSize: {
        type: String,
        required: false,
        default: () => "36pt"
      }

  },
  computed: {
    textDisplay: function() {
      let input = this.textIn || "";
      let acronym = input.split(/\s/).reduce((response, word) => response += word.slice(0, 1), "");
      let retVal = String(acronym.charAt(0)) + String((acronym.length > 1) ? acronym.charAt(acronym.length - 1) : "");
      return retVal;
    },
    showInitials: function() {
      return (!this.pictureUrl || /^\s*$/.test(this.pictureUrl));
    }
  }
};
</script>

<style>
  .picture-placeholder-container {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    /* background: #898c7f; */
  }

  .picture-placeholder-picture {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .picture-placeholder-initials {
    position: absolute;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

  }
</style>
